import { COUNTRY_GATED_FEATURE_TYPE_CODES } from "@/v2-backoffice-client/feature/feature.constants"
import {
  COUNTRY_EMPTY_MEANING,
  type CountryEmptyMeaning,
} from "@/v2-backoffice-client/feature/country/feature.country.constants"

/**
 * What an empty country list means for a feature of the given type. Unknown
 * or missing type reads as the lenient default, which is also what every
 * non-GIS feature gets.
 */
export function getCountryEmptyMeaning(
  featureTypeCode: number | null | undefined,
): CountryEmptyMeaning {
  return featureTypeCode != null &&
    COUNTRY_GATED_FEATURE_TYPE_CODES.has(featureTypeCode)
    ? COUNTRY_EMPTY_MEANING.nowhere
    : COUNTRY_EMPTY_MEANING.everywhere
}
